import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASEDOMAIN;

export default {
  namespaced: true,
  actions: {
    login: (context, payload) => {
      return axios({
        method: "POST",
        url: BASE_URL + "/auth/login",
        data: payload,
      });
    },
    register: (context, payload) => {
      return axios({
        method: "POST",
        url: BASE_URL + "/auth/register",
        data: payload,
      });
    },

    get: ({ dispatch }, payload) => {
      return dispatch("http", {
        method: "GET",
        url: BASE_URL + payload.url,
      });
    },
    post: ({ dispatch }, payload) => {
      return dispatch("http", {
        method: "POST",
        url: BASE_URL + payload.url,
        data: payload.data,
      });
    },
    http: ({ dispatch, rootGetters }, payload) => {
      let token = rootGetters["auth/getToken"];
      payload.headers = { Authorization: "Bearer " + token };
      return new Promise((resolve, reject) => {
        axios(payload)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            if (err.response.status === 401) {
              dispatch("auth/logout", null, { root: true });
            }
            reject(err);
          });
      });
    },
  },
};
